import React, { useEffect, useContext } from "react"
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet"
import L from "leaflet"
import { useTranslation } from "react-i18next"
import { useFetchApi } from "../../hooks"
import { LangContext } from "../../LangProvider"
import pinMap from "../../assets/img/pinMap.png"

function OurImpact() {
  const { t } = useTranslation()
  const { lang } = useContext(LangContext)
  const [{ data: cord }, doFetch] = useFetchApi(`/impact?lang=${lang}`, [])
  const center = {
    lat: -0.7,
    lng: 120,
    zoom: 5
  }

  const icon = L.icon({
    iconUrl: pinMap,
    iconSize: [40, 41],
    iconAnchor: [20, 41],
    popupAnchor: [0, -41]
  })
  const corner1 = L.latLng(-8, 90.5)
  const corner2 = L.latLng(10, 150.8)
  const bounds = L.latLngBounds(corner1, corner2)

  useEffect(() => {
    doFetch(`/impact?lang=${lang}`, [])
  }, [lang])

  return (
    <div className="uk-flex uk-padding-small uk-flex-column uk-text-center uk-margin-large-bottom uk-padding-remove-bottom bg-gray">
      <h1 className="uk-margin-bottom uk-text-bold">
        {t("ourprogram.ourImpact")}
      </h1>
      <div className="uk-flex uk-flex-column uk-margin-left uk-margin-right">
        <div className="uk-width-1-1 uk-margin-auto map-container">
          <MapContainer
            center={[center.lat, center.lng]}
            zoom={center.zoom}
            boxZoom={false}
            maxBoundsViscosity={1.0}
            maxBounds={bounds}
            minZoom={5}
            className="uk-width-1-1 uk-height-1-1"
          >
            <TileLayer
              attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {cord.map((el, idx) => (
              <Marker
                key={idx}
                icon={icon}
                position={[el.latitude, el.longtitude]}
              >
                <Popup>
                  <h5 className="font-red">{el.title}</h5>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>

        <div className="uk-width-2-3 uk-align-center">
          <p>{t("ourprogram.ourImpactDesc")}</p>
        </div>
      </div>
    </div>
  )
}

export default OurImpact
